import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  heading: {
    color: '#333333',
    marginBottom: 20,
    
  },
}));